import { NgxSpinnerModule } from '@digipay/ngx-spinner';
import { NgxButtonComponent } from '@digipay/ngx-button';

import { PENDING_TRANSACTIONS_ROUTE, PORTFO } from '../../../../data-access/constants/app-routes';
import { Component, inject, input, output, signal } from '@angular/core';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { ICustomerPortfolio } from '../../../../components/core/models/customer-portfolio.interface';
import { NgxIcon } from '@digipay/ngx-icon';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { DecimalPipe } from '@angular/common';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'wealth-applet-home-assets',
  templateUrl: './home-assets.component.html',
  styleUrls: ['./home-assets.component.scss'],
  standalone: true,
  imports: [NgxSpinnerModule, NgxButtonComponent, NgxIcon, NgxBadgeModule, DecimalPipe, SpinnerComponent],
})
export class HomeAssetsComponent {
  portfolio = input<ICustomerPortfolio>();
  isLoading = input<boolean>();
  isLoadingNewData = input.required<boolean>();

  canSee = signal<boolean>(false);
  hideDetail = signal<boolean>(true);

  handleUpdateData = output();
  private navigationService = inject(WealthNavigationService);

  goToPortfo() {
    this.navigationService.navigate([PORTFO]);
  }

  updateData() {
    this.handleUpdateData.emit();
  }

  pendingTransactions() {
    this.navigationService.navigate([PENDING_TRANSACTIONS_ROUTE], {
      queryParams: {
        status: ['Draft', 'Waiting'],
        type: 'Buy',
      },
    });
  }
}
